import { Component, OnInit, Input, TemplateRef } from '@angular/core';

// TODO: During ng-build, we get this warning:
// 'TemplateRef' is imported from external module '@angular/core' but never used
// Looks like this is a bug with Angular compiler: https://github.com/dherges/ng-packagr/issues/710#issuecomment-375890469
@Component({
    styles: [`
        .pershing-responsive: {
            box-sizing: border-box;
            width: 100%;
        }
    `],
    selector: 'pershing-responsive',
    templateUrl: 'pershing-responsive.component.html'
})
export class PershingResponsiveComponent implements OnInit {
    pershingResponsiveWindow: string;

    @Input()
    respondToWindow: boolean = false;

    @Input()
    small: TemplateRef<Object>;

    @Input()
    medium: TemplateRef<Object>;

    @Input()
    large: TemplateRef<Object>;

    sizeConfig: any;

    constructor() {}

    // Might need to update the range per Material responsive UI breakpoint
    // https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-patterns
    ngOnInit(): void {
        if (this.respondToWindow) {
            this.pershingResponsiveWindow = null;
        } else {
            this.pershingResponsiveWindow = new Date().getMilliseconds().toString() + Math.random();
        }
        this.sizeConfig = {
            small: { sizes: { window: this.pershingResponsiveWindow, min: 0, max: 595 } },
            medium: { sizes: { window: this.pershingResponsiveWindow, min: 596, max: 811 } },
            large: { sizes: { window: this.pershingResponsiveWindow, min: 812, max: 9999 } }
        };
    }
}
